import { MyContext } from "../../../../pages/Funnel";
import clsx from "clsx";
import { useContext } from "react";

import { MdArrowForwardIos } from "react-icons/md";

const NavigationButton = ({ swiperRef, type = "prev" }) => {
  const  details  = useContext(MyContext);
  return (
    <button
      onClick={() => {
        type === "prev"
          ? swiperRef.current.slidePrev()
          : swiperRef.current.slideNext();
      }}
      aria-label={type === "prev" ? "previous course" : "next course"}
      name={type}
      style={{ backgroundColor: details?.state.color }}
      className={clsx(
        "absolute top-[46%] -translate-y-[50%] z-10 bg-primary rounded-full h-10 w-10 flex justify-center items-center shadow-lg  max-sm:h-8 max-sm:w-8",
        type === "prev"
          ? "left-0 -translate-x-1/2 max-sm:ml-1"
          : "right-0 translate-x-1/2 max-sm:mr-1"
      )}>
      {type === "prev" ? (
        <MdArrowForwardIos
          style={{ backgroundColor: details?.state.color }}
          className="rotate-180 text-white bg-primary text-xl max-sm:text-base"
        />
      ) : (
        <MdArrowForwardIos className="text-white  text-xl max-sm:text-base" />
      )}
    </button>
  );
};

export default NavigationButton;
